import React, { useState, useEffect } from 'react'
import CardForm from '../CardForm/CardForm';
import axios from 'axios'
import { useNavigate } from 'react-router-dom';
import TipSelection from '../Tips/TipSelection'
import PhoneInput from '../PhoneInput/PhoneInput';

const PayForm = ({ paymentData }) => {
  const { amount = "", clientCode = "", linkName = "" } = paymentData || {};
  const navigate = useNavigate()
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL

  const countries = [
    { name: 'KENYA', code: '+254', currency: 'KSH' },
    // { name: 'UGANDA', code: '+256', currency: 'UGX' },
    // { name: 'TANZANIA', code: '+255', currency: 'TZS' },
    // { name: 'ETHIOPIA', code: '+251', currency: 'ETB' },
    // { name: 'RWANDA', code: '+250', currency: 'RWF' }
  ]

  const [paymentMethod, setPaymentMethod] = useState('mobile_money')
  const [selectedCountry, setSelectedCountry] = useState(countries[0])
  const [isButtonLoading, setIsButtonLoading] = useState(false)
  const [mpesaRequestData, setMpesaRequestData] = useState({
    country: selectedCountry.name,
    clientCode,
    currency: selectedCountry.currency,
    msisdn: selectedCountry.code.slice(1), // Initialize with country code, removing the '+'
    amount,
    gatewayChannel: "MOMO",
    gatewayChannelType: "MPESA",
    linkName
  })
  const [isValidPhoneNumber, setIsValidPhoneNumber] = useState(false)

  useEffect(() => {
    if (paymentData) {
      setMpesaRequestData(prevState => ({
        ...prevState,
        clientCode: paymentData.clientCode || "",
        amount: paymentData.defaultAmount || "",
        linkName: paymentData.linkName || ""
      }))
    }
  }, [paymentData])

  useEffect(() => {
    setMpesaRequestData(prevState => ({
      ...prevState,
      country: selectedCountry.name,
      currency: selectedCountry.currency
    }))
  }, [selectedCountry])

  const handlePaymentMethodChange = (event) => {
    setPaymentMethod(event.target.value);
  };

  const handleMPESApayment = async (event) => {
    try {
      event.preventDefault()
      console.log(mpesaRequestData);
      setIsButtonLoading(true)
      const resp = await axios.post(`${BACKEND_URL}/api/payments/pay`, mpesaRequestData)
      console.log(resp.data.data.internalID);
      navigate(`/payment-status/${resp.data.data.internalID}`)
      setIsButtonLoading(false)
    } catch (error) {
      console.error(error)
    }
  }

  const handleChange = (e) => {
    const { name, value } = e.target
    if (name === 'country') {
      const newCountry = countries.find(c => c.name === value)
      setSelectedCountry(newCountry)
    } else {
      setMpesaRequestData((prevState) => ({
        ...prevState,
        [name]: value
      }))
    }
  }

  if (!paymentData) {
    return <div>Loading payment data...</div>;
  }

  return (
    <form onSubmit={handleMPESApayment} className='md:w-1/2 p-4 shadow-lg rounded-lg flex-1 bg-white border-2 border-gray-100'>
      <div className="mb-4 gap-4">
        <div className="country flex-1 mb-4">
          <label htmlFor="country" className="block text-md leading-6 font-bold">Country</label>
          <select
            id="country"
            name="country"
            autoComplete="country-name"
            value={selectedCountry.name}
            onChange={handleChange}
            required
            className="w-full rounded-md bg-gray-100 py-1.5 px-1 outline-none focus:ring-[#e9b22c] sm:text-sm sm:leading-6 p"
          >
            {countries.map((country) => (
              <option key={country.name} value={country.name}>
                {country.name}
              </option>
            ))}
          </select>
        </div>
        <div className="amount flex-1">
          <TipSelection mpesaRequestData={mpesaRequestData} setMpesaRequestData={setMpesaRequestData} />
        </div>
      </div>
      <div className="payment-type bg-gray-100 p-4 rounded-lg ">
        <div className="payment-selector mb-4">
          <label className="block font-medium text-gray-700 mb-2">Payment Type</label>
          <div className="flex gap-2">
            <div
              className={`px-2 py-1 rounded-lg cursor-pointer ${paymentMethod === 'mobile_money'
                ? 'bg-indigo-500 border-2 bg-white border-[#e9b22c] '
                : 'bg-white border border-gray-200 text-gray-700 hover:bg-gray-100'
                }`}
              onClick={() => setPaymentMethod('mobile_money')}
            >
              Mobile Money
            </div>
            <div
              className={`px-2 py-1 rounded-lg cursor-pointer ${paymentMethod === "card_payment"
                ? 'bg-indigo-500 border-2 bg-white border-[#e9b22c] '
                : 'bg-white border border-gray-200 text-gray-700 hover:bg-gray-100'
                }`}
              // onClick={() => setPaymentMethod('card_payment')}
              title='Coming Soon!'
            >
              Card Payment
            </div>
          </div>
        </div>

        <div>
          {paymentMethod === 'mobile_money' && (
            <div>
              <div className='flex gap-6 mb-4'>
                <div className="inline-flex items-center">
                  <label className="relative flex items-center p-3 rounded-full cursor-pointer" htmlFor="black">
                    <input name="color" type="radio"
                      className="before:content[''] peer relative h-5 w-5 cursor-pointer appearance-none rounded-full border border-gray-400 text-gray-900 transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-12 before:w-12 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-blue-gray-500 before:opacity-0 before:transition-opacity checked:border-[#e9b22c] checked:before:bg-[#e9b22c] hover:before:opacity-10"
                      id="black" defaultChecked />
                    <span
                      className="absolute text-gray-900 transition-opacity opacity-0 pointer-events-none top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 peer-checked:opacity-100">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5" viewBox="0 0 16 16" fill="#e9b22c">
                        <circle data-name="ellipse" cx="8" cy="8" r="8"></circle>
                      </svg>
                    </span>
                  </label>
                  <span>Safaricom</span>
                </div>
                <div className="inline-flex items-center">
                  <label className="relative flex items-center p-3 rounded-full cursor-pointer" htmlFor="black">
                    <input name="color" type="radio"
                      className="before:content[''] peer relative h-5 w-5 cursor-pointer appearance-none rounded-full border border-gray-400 text-gray-900 transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-12 before:w-12 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-blue-gray-500 before:opacity-0 before:transition-opacity checked:border-[#e9b22c] checked:before:bg-[#e9b22c] hover:before:opacity-10"
                      id="black" title='Coming Soon!' disabled/>
                    <span
                      className="absolute text-gray-900 transition-opacity opacity-0 pointer-events-none top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 peer-checked:opacity-100">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5" viewBox="0 0 16 16" fill="#e9b22c">
                        <circle data-name="ellipse" cx="8" cy="8" r="8"></circle>
                      </svg>
                    </span>
                  </label>
                  <span>Airtel</span>
                </div>
              </div>
              <PhoneInput
                selectedCountry={selectedCountry}
                countries={countries}
                handleChange={handleChange}
                mpesaRequestData={mpesaRequestData}
                setMpesaRequestData={setMpesaRequestData}
                setIsValidPhoneNumber={setIsValidPhoneNumber}
              />
            </div>
          )}

          {paymentMethod === 'card_payment' && (<CardForm />)}
        </div>
      </div>
      {
        isButtonLoading ? (
          <button disabled type="button" className="w-full text-white bg-[#f5e093] px-5 py-2.5 text-sm font-medium mt-2 inline-flex justify-center rounded-lg cursor-pointer">
            <svg aria-hidden="true" role="status" className="inline w-4 h-4 me-3 text-white animate-spin" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#e9b22c" />
              <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor" />
            </svg>
            Loading...
          </button>
        ) : (
          <button
            type="submit"
            disabled={!isValidPhoneNumber}
            className={`flex w-full items-center justify-center rounded-lg bg-[#e9b22c] px-5 py-2.5 text-sm font-medium hover:bg-[#e9b22c] focus:outline-none focus:ring-1  focus:ring-[#e9b22c] mt-2 text-white ${!isValidPhoneNumber ? 'opacity-50 cursor-not-allowed' : ''}`}
          >
            Pay now
          </button>
        )
      }
    </form>
  )
}

export default PayForm